module.exports = __webpack_public_path__ + "img/cmdb2.dfa26bfa.png";